import { Injectable, Renderer2, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { IframeMessage } from '@longnecktech/splash-commons-fe';
import { SessionService } from '@services/session.service';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JackpotLibService {
  private session = inject(SessionService);
  private router = inject(Router);

  private jackpotListener?: () => void;

  launchJackpotFooter(): void {
    this.session.showTestJackpot$
      .pipe(
        filter((showTestJackpot) => showTestJackpot && !!window.SplashJackpots),
        take(1),
      )
      .subscribe(() => {
        if (!SplashJackpots.footer.isLaunched()) {
          SplashJackpots.footer.launch({
            token: this.session.thirdPartyToken,
            params: {
              fakeWinner: true,
            },
          });
        }
      });
  }

  showJackpotResult(): void {
    this.session.showTestJackpot$.pipe(take(1)).subscribe((showTestJackpot) => {
      if (
        showTestJackpot &&
        !!window.SplashJackpots &&
        !SplashJackpots.wonJackpot.isLaunched()
      ) {
        SplashJackpots.wonJackpot.launch({
          token: this.session.thirdPartyToken,
          params: {
            fakeWinner: true,
          },
        });
      } else {
        this.navigateToResultPage();
      }
    });
  }

  hideJackpotResult(renderer: Renderer2): void {
    this.jackpotListener = renderer.listen(
      'window',
      'message',
      (event: MessageEvent) => {
        if (
          event.origin === environment.jackpotFrontendUrl &&
          event.data?.type === IframeMessage.JackpotWinClose
        ) {
          SplashJackpots.wonJackpot.hide();
          this.navigateToResultPage();
          // Remove the listener after handling the message
          this.removeJackpotListener();
        }
      },
    );
  }

  navigateToResultPage(): void {
    this.session.isMobile$.pipe(take(1)).subscribe((isMobile) => {
      this.router.navigate([isMobile ? '/m/results' : '/d/results'], {
        queryParamsHandling: 'preserve',
      });
    });
  }

  removeJackpotListener(): void {
    if (this.jackpotListener) {
      this.jackpotListener();
      this.jackpotListener = undefined; // Clean up the reference
    }
  }
}
